// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import React from 'react';
import { useI18n } from '../i18n';
const ConfirmModal = ({ message, onConfirm, onCancel, danger = true }) => {
  const { t } = useI18n();
  return (
  <div onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(2px)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
    <div onClick={e => e.stopPropagation()} style={{ background: 'var(--bg-surface)', borderRadius: 12, border: '1px solid var(--gray)', padding: '24px 28px', maxWidth: 380, width: '100%', boxShadow: 'var(--shadow-md)' }}>
        <p style={{ fontSize: 14, color: 'var(--black)', marginBottom: 20, lineHeight: 1.6 }}>{message}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{ padding: '8px 16px', borderRadius: 8, background: 'transparent', border: '1px solid var(--gray)', fontSize: 13, cursor: 'pointer', color: 'var(--black)' }}>
            {t('pref_cancel')}
          </button>
          <button onClick={onConfirm} style={{ padding: '8px 16px', borderRadius: 8, background: danger ? '#ef4444' : 'var(--blue)', color: 'white', border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            {t('confirm_action')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;